import { VersionResponse } from '@/types/service-response'

export class Version {
  private constructor (
    readonly frontendVersion: string,
    readonly frontendTableVersion: string,
    readonly backendVersion: string,
    readonly backendTableVersion: string,
    readonly DBTableVersion: string,
    readonly statusFrontend: boolean,
    readonly statusBackend: boolean,
    readonly status: boolean
  ) {}

  static createFromResponse (response: VersionResponse): Version {
    return new Version(
      response.FrontendVersion,
      response.FrontendTableVersion,
      response.BackendVersion,
      response.BackendTableVersion,
      response.DbTableVersion,
      response.StatusFrontend,
      response.StatusBackend,
      response.StatusAll
    )
  }
}
